import { FormControl, FormLabel } from "react-bootstrap";
import { IFieldEditor } from "../../../../models/Interfaces";

const DecimalNumberEditor = (props: IFieldEditor) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onValueChange(props.property.Id, event.target.value);
  }

  return (
    <>
      <FormLabel>{props.property.DisplayLabel}</FormLabel>
      <FormControl
        type="number"
        step="0.01"
        value={props.property.PublishedValue ?? ""}
        onChange={handleChange}
      />
    </>
  );
}

export default DecimalNumberEditor;